import { Link } from 'react-router-dom';

const AUDIENCES = [
  {
    title: 'Schools',
    items: [
      'Teacher professional development',
      'Teacher performance dashboard',
      'School analytics',
      'School resource repository',
      'Virtual STEM laboratories',
      'School subscriptions with unlimited teacher accounts',
    ],
  },
  {
    title: 'Teacher Training Colleges',
    items: [
      'Trainer certification',
      'Student teacher resources',
      'Teaching practice support',
      'Digital curriculum repository',
    ],
  },
  {
    title: 'Universities',
    items: [
      'Faculty development',
      'Research collaboration',
      'Virtual laboratories',
      'Digital learning resources',
    ],
  },
  {
    title: 'Ministries of Education',
    items: [
      'National teacher training',
      'Monitoring teacher participation',
      'National dashboards and regional analytics',
      'Learning reports and certification management',
      'Curriculum implementation monitoring',
    ],
  },
  {
    title: 'NGOs & Development Partners',
    items: [
      'Programme implementation',
      'Beneficiary tracking',
      'Monitoring and evaluation dashboards',
      'Training management and impact reports',
    ],
  },
];

export function InstitutionsPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-14">
      <h1 className="text-3xl font-bold text-ink-900">Institutional solutions</h1>
      <p className="mt-3 max-w-2xl text-ink-700">
        Designed for organisations managing many educators — from a single school to a national
        rollout.
      </p>

      <section className="mt-8 rounded-xl border border-brand-300 bg-brand-50 p-6">
        <h2 className="text-lg font-semibold text-brand-900">
          Curriculum coverage, not just course completions
        </h2>
        <p className="mt-2 text-sm text-ink-700">
          Content on this platform is tagged to the curriculum's own outcome statements. That turns
          the hardest question a ministry asks —{' '}
          <em>which outcomes has this county actually covered, and where are the gaps?</em> — into a
          report rather than a survey. Completion counts alone cannot answer it.
        </p>
      </section>

      <div className="mt-10 grid gap-6 sm:grid-cols-2">
        {AUDIENCES.map(audience => (
          <section key={audience.title}>
            <h2 className="text-lg font-semibold text-ink-900">{audience.title}</h2>
            <ul className="mt-2 space-y-1 text-sm text-ink-700">
              {audience.items.map(item => (
                <li key={item} className="flex gap-2">
                  <span aria-hidden="true" className="text-brand-700">
                    ▸
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>

      <section className="mt-12">
        <h2 className="text-xl font-semibold text-ink-900">How a rollout works</h2>
        <ol className="mt-3 space-y-3 text-sm text-ink-700">
          <li>
            <strong className="text-ink-900">1. Structure.</strong> Your organisation is created as a
            tree — ministry, counties, schools — so every report rolls up it.
          </li>
          <li>
            <strong className="text-ink-900">2. Curriculum pack.</strong> One installation puts your
            curriculum's outcomes, courses and laboratories into each tenant. Re-running it is safe.
          </li>
          <li>
            <strong className="text-ink-900">3. People.</strong> Staff join by invitation or by a
            verified email domain, and administrators grant roles inside their own organisation.
          </li>
          <li>
            <strong className="text-ink-900">4. Reporting.</strong> Each level sees its own scope:
            a head teacher sees their school, a county officer sees their county, a national analyst
            sees everything beneath them.
          </li>
        </ol>

        <Link to="/contact" className="btn-primary mt-6">
          Talk to us about a rollout
        </Link>
      </section>
    </div>
  );
}
